import Datetime from 'utils/datetime/datetime'

const LAST_QUARTER_HOUR_START_MINUTES = 45

export function resolveElplanBidsQueryEndTime(endTime: ISODateTime): ISODateTime {
  return new Datetime(endTime).addMinutes(LAST_QUARTER_HOUR_START_MINUTES).ISOString
}
